module.exports = __webpack_public_path__ + "img/bicc_unil.5a702fde.png";